import { useTranslation } from "react-i18next";
import { ao3Features } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

const ao3Tones = [
  "bg-primary-100 text-primary-700 dark:text-primary-400",
  "bg-accent-100 text-accent-800",
  "bg-secondary-200 text-secondary-900",
];

export default function Ao3Features() {
  const { t } = useTranslation();

  return (
    <section id="ao3-features" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Ao3Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 dark:text-primary-400">{t("features.badge")}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">{t("features.title")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t("features.subtitle")}</p>
        </Ao3Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 md:mt-14 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {ao3Features.map((feature, index) => (
            <Ao3Reveal key={feature.id} delay={index * 70}>
              <article className="flex h-full flex-col gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200 md:p-6">
                <span className={`flex h-12 w-12 items-center justify-center rounded-md ${ao3Tones[index % ao3Tones.length]}`}>
                  <i className={`${feature.icon} text-2xl leading-none`} />
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{t(`features.items.${feature.id}.title`)}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{t(`features.items.${feature.id}.desc`)}</p>
              </article>
            </Ao3Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}